import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import CalenderPlus from '../../assets/images/calenderplus.png';
import AppReview from '../../assets/images/appReview.png';
import AffiliateCode from '../../assets/images/affiliateCode.png';
import StartEarning from '../../assets/images/dollarSymbol.png';

const HowItWorks = () => (
  <Box width="100%" py={8} mt={-3} bgcolor="#fff" px={{ xs: 2, md: 4 }}>
    <Box textAlign="center" mb={6}>
      <Typography fontFamily="Lato" fontWeight={900} variant="h4">
        Get Started in 4 Easy Steps
      </Typography>
      <Typography
        pt={2}
        fontFamily="Lato"
        fontWeight={400}
        fontSize="16px"
        lineHeight="150%"
        letterSpacing="0.5px"
        px={{ xs: 1, md: 10 }}
      >
        Becoming a CanAm Affiliate is simple, fast, and rewarding. Here&apos;s how to start earning in four easy steps:
      </Typography>
    </Box>
    <TimelineZigZag />
  </Box>
);

const steps = [
  {
    title: 'Quick Sign-Up',
    text: 'Fill out a short application form on our website—it only takes a few minutes!',
    icon: <img src={CalenderPlus} alt="Sign Up" width={16} height={17} />,
  },
  {
    title: 'Application Review',
    text: 'Our team will review your submission. We’re on the lookout for passionate, travel-loving affiliates who align with our brand.',
    icon: <img src={AppReview} alt="Review" width={16} height={18} />,
  },
  {
    title: 'Get Your Affiliate Code',
    text: 'Once approved, you’ll receive an email with your personalized affiliate code. Use this code to track all your referrals.',
    icon: <img src={AffiliateCode} alt="Affiliate Code" width={16} height={16} />,
  },
  {
    title: 'Start Earning',
    text: 'Begin sharing your unique link with friends, family, and followers. Every successful referral earns you a commission!',
    icon: <img src={StartEarning} alt="Earning" width={9} height={16} />,
  },
];

const TimelineZigZag = () => (
  <Box sx={{ px: 1, maxWidth: '1000px', mx: 'auto' }}>
    {steps.map((step, index) => {
      const isLeft = index % 2 === 0;

      return (
        <Grid
          container
          spacing={2}
          alignItems="center"
          key={index}
          direction={{
            xs: 'column',
            sm: isLeft ? 'row' : 'row-reverse',
          }}
          sx={{ mb: { xs: 5, md: 4 }, mt: 0 }}
        >
          {/* Text */}
          <Grid item xs={12} sm={5}>
            <Box
              textAlign={{ xs: 'center', sm: isLeft ? 'right' : 'left' }}
              mx={{ xs: 0, sm: isLeft ? 2 : 1 }}
            >
              <Typography variant="h6" fontWeight="bold">
                {step.title}
              </Typography>
              <Typography>{step.text}</Typography>
            </Box>
          </Grid>

          {/* Icon with vertical line */}
          <Grid item xs={12} sm={2}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  backgroundColor: '#FFEFE6',
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                mb={1}
              >
                {step.icon}
              </Box>

              {/* Vertical line */}
              {index !== steps.length - 1 && (
                <Box
                  sx={{
                    width: '2px',
                    height: { xs: '40px', md: '60px' },
                    position: 'absolute',
                    top: '100%',
                    backgroundImage: 'linear-gradient(#bbb 33%, rgba(255,255,255,0) 0%)',
                    backgroundPosition: 'left',
                    backgroundSize: '2px 8px',
                    backgroundRepeat: 'repeat-y',
                    margin: '0 auto',
                  }}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      );
    })}
  </Box>
);

export default HowItWorks;
